import React, { ReactNode } from "react";

function FooterDialog({ children }: { children: ReactNode }) {
  return (
    <div
      style={{
        height: "4vh",
        backgroundColor: "var(--main)",
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
      }}
    >
      {children}
    </div>
  );
}

export default FooterDialog;
